(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-product-grid-sortby"] && !Shopify.designMode) return;
  try {
    class SortbyMobile extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.utils-sortby-mobile-button');
    this.triggerButton = document.querySelector('[data-productgrid-mobile-trigger-sort-button]');
    this.scrollState = this.scrollTop;
    this.accordionState = new Array(...this.querySelectorAll("details.filter-dropdown[open]")).map((accordion) => accordion.dataset.filterId);
  }

  connectedCallback() {
    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleClick.bind(this));
    });
    this.triggerButton.addEventListener('click', this.handleTriggerClick.bind(this));
    document.addEventListener('click', this.handleDocumentClick.bind(this));
  }
  handleDocumentClick(event) {
    if (!this.contains(event.target) && !this.triggerButton.contains(event.target)) {
      this.triggerButton.classList.remove('open');
      this.classList.remove('active');
    }
  }
  handleTriggerClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.triggerButton.classList.toggle('open');
    this.classList.toggle('active');
  }
  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.buttons.forEach(button => {
      button.classList.remove('active');
    });
    event.currentTarget.classList.add('active');
    this._updateContent(this._addParams('sort_by', event.currentTarget.dataset.value, new URLSearchParams(window.location.search)).toString(), {
      elements: [".filter-drawer__form", ".productgrid--items", ".filter-drawer__footer", "#paginationContainer", "#mobile-filter-trigger"],
    });
    document.querySelectorAll('.utils-sortby--active').forEach(active => {
      active.innerHTML = event.currentTarget.querySelector('.utils-sortby-mobile-button-text').innerHTML;
    });
    this.triggerButton.classList.remove('open');
    this.classList.remove('active');
  }
  _removeParams(name, val, params) {
    params.entries().forEach(([key, value]) => {
      if (key === name) {
        if (value === val) {
          params.delete(key, value);
        }
      }
    });
    return params;
  }
  _addParams(name, val, params) {
    params.set(name, val);
    return params;
  }
  _updateContent(newParams, { elements = [] } = {}) {
    fetch(`${window.location.pathname}?${newParams}`)
      .then((response) => response.text())
      .then((html) => {
        const domParser = new DOMParser();
        const doc = domParser.parseFromString(html, "text/html");
        if (elements.length > 0) {  
          elements.forEach((element) => {
            const currentElement = document.querySelectorAll(element);
            if (currentElement.length > 0) {
              currentElement.forEach((elem, index) => {
                const newElement = doc.querySelectorAll(element)[index];
                if(!newElement) return;
                if (newElement.classList.contains('filter-drawer__form')) {
                  newElement.scrollTop = this.scrollState;
                  newElement.querySelectorAll("details.filter-dropdown").forEach((accordion) => {
                    if (accordion.dataset.filterId) {
                      accordion.open = this.accordionState.includes(accordion.dataset.filterId);
                    }
                  });
                }
                elem.innerHTML = newElement.innerHTML;
              });
            }
          });
        }
        document.dispatchEvent(new CustomEvent('productgrid:sortby:updated', { detail: { newParams: newParams } }));
        const sanitizedParams = new URLSearchParams(newParams);
        sanitizedParams.delete("section_id");
        newParams = sanitizedParams.toString();
        window.history.pushState(
          null,
          "",
          `${window.location.pathname}${newParams.length > 0 ? "?" : ""}${newParams}`,
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }
  disconnectedCallback() {
    this.buttons.forEach(button => {
      button.removeEventListener('click', this.handleClick.bind(this));
    });
    this.triggerButton.removeEventListener('click', this.handleTriggerClick.bind(this));
  }
}

customElements.define('sortby-mobile', SortbyMobile);
  } catch(e) { console.error(e); }
})();

})();
